/**
 * オフラインインジケータコンポーネント
 *
 * ネットワーク状態を監視し、オフライン時にバナーを表示する。
 * 同期待ちデータがある場合は件数も表示する。
 */

import { useEffect, useState } from 'react';
import { offlineStorage } from '../services/offlineStorage';
import { onSyncStateChange } from '../services/syncService';

export default function OfflineIndicator() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [pendingCount, setPendingCount] = useState(0);

  // ネットワーク状態の監視
  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  // 同期待ち件数の監視
  useEffect(() => {
    let receivedSyncNotification = false;
    // syncServiceからの通知を購読
    const unsubscribe = onSyncStateChange((count) => {
      receivedSyncNotification = true;
      setPendingCount(count);
    });

    // 初回読み込み
    offlineStorage.countAllPending().then((count) => {
      if (!receivedSyncNotification) {
        setPendingCount(count);
      }
    });

    return unsubscribe;
  }, []);

  // オンラインかつ同期待ちデータなし -> 何も表示しない
  if (isOnline && pendingCount === 0) {
    return null;
  }

  return (
    <div
      className={`sticky top-0 z-50 text-center py-2 text-sm font-medium ${
        isOnline
          ? 'bg-blue-500 text-white'
          : 'bg-amber-500 text-white'
      }`}
    >
      {!isOnline && (
        <span>
          オフラインモード - 検査データはローカルに保存されます
        </span>
      )}
      {isOnline && pendingCount > 0 && (
        <span>
          同期待ちデータ: {pendingCount}件 - 同期中...
        </span>
      )}
      {!isOnline && pendingCount > 0 && (
        <span className="ml-2">
          （同期待ち: {pendingCount}件）
        </span>
      )}
      {!isOnline && (
        <div className="text-xs opacity-90">
          容量にお気をつけください
        </div>
      )}
    </div>
  );
}
